const INCOME_KEY = 'statnlp-income'
const EXPENSE_KEY = 'statnlp-expense'

class StorageService {
  saveIncome (data) {
    this.saveData(INCOME_KEY, data)
  }
  saveExpense (data) {
    this.saveData(EXPENSE_KEY, data)
  }
  loadIncome () {
    return this.loadData(INCOME_KEY)
  }
  loadExpense () {
    return this.loadData(EXPENSE_KEY)
  }
  loadData (key) {
    try {
      return JSON.parse(localStorage.getItem(key))
    } catch (error) {
      return []
    }
  }
  saveData (key, data) {
    localStorage.setItem(key, JSON.stringify(data))
  }
}

export default new StorageService()



// WEBPACK FOOTER //
// ./src/services/StorageService.js